import React from 'react'
import { Avatar, Input } from '@driftt/tide-core'
import moment from 'moment'

const SelectCell = ({ id }, onSelect, isSelected) => {
  return (
    <Input type="checkbox" checked={isSelected} onChange={(event) => onSelect(id, event)} />
  )
}

const NameCell = (contact, goToContact) => {
  return (
    <div className="contact-name-cell" onClick={() => goToContact(contact.id)}>
      <Avatar user={contact} type="user"/>
      <div className="contact-name">
        <span data-private>{contact.name ? contact.name : contact.email}</span>
      </div>
    </div>
  )
}

const EmailCell = ({email}) => <div data-private>{email ? email : 'Unavailable'}</div>

const LeadStageCell = ({attributes}) => <div>{`${attributes._classification || 'N/A'}`}</div>

const LastContactedCell = ({attributes}) => {
  if (!attributes.last_contacted) {
    return <div>-</div>
  }

  return <div>{moment(attributes.last_contacted).fromNow()}</div>
}

export const RowFormatter = (contact, onDelete, onViewDetail, onSelect, selectedMembers, goToContact) => ({
  data: [
    {content: SelectCell(contact, onSelect, (selectedMembers && selectedMembers.includes(contact.id)))},
    {content: NameCell(contact, goToContact)},
    {content: EmailCell(contact)},
    {content: LeadStageCell(contact)},
    {content: LastContactedCell(contact)}
  ]
})
